<template lang="pug">
b-container(fluid style="height: 85%")
  b-row.mt-4
    b-col.col-12
      b-row.mb-4.align-items-center
        b-col.col-lg-4.col-md-6.col-12.mb-3.mb-md-0
          b-form-group.toggle-button(v-if="selectedTable === 'CIP'")
            b-form-radio-group(:options="phaseOptions" v-model="selectedPhase" buttons  size="md" button-variant="outline-primary")
        
        b-col.col-lg-4.col-md-6.col-12.mb-3.mb-md-0.d-flex.justify-content-center
          b-form-group
            b-form-radio-group.toggle-buttons(
              v-model="selectedTable"
              :options="tableOptions"
              buttons
              button-variant="outline-primary"
              size="md"
            )
        
        b-col.col-lg-4.col-md-12.col-12.d-flex.justify-content-end
          .search-container(style="position: relative; width: 100%; max-width: 300px;")
            BIconSearch.search-icon(style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); color: #6c757d; z-index: 2;")
            b-input.search-input(
              placeholder="Search by name..."
              type="text"
              v-model="inputSearchItemList"
              style="padding-left: 45px; border-radius: 25px; border: 2px solid #dee2e6; transition: all 0.3s ease;"
              @focus="$event.target.style.borderColor = '#007bff'; $event.target.style.boxShadow = '0 0 0 0.2rem rgba(0,123,255,.25)'"
              @blur="$event.target.style.borderColor = '#dee2e6'; $event.target.style.boxShadow = 'none'"
            )
      
      b-row
        b-col.col-12
          .stats-container.mb-3.p-3.bg-light.rounded.d-flex.justify-content-between.align-items-center
            .stats-text
              //- span.font-weight-semibold.text-muted {{ currentTableData?.length || 0 }} 
              span.text-secondary  {{ filteredClientsList.length }} records found
            .table-indicator.badge(:class="selectedTable === 'CIP' ? 'badge-primary' : 'badge-info'")
              | {{ selectedTable }} Table
          .table-container.shadow-sm.rounded
            .table-wrapper
              b-table.custom-table(
                :fields="currentTableFields" 
                :items="filteredClientsList"
                :busy="isFetchingAdminDashboardData"
                thead-class="table-header-custom"
                tbody-tr-class="table-row-hover"
                show-empty
                responsive
                striped
              )
                template(#table-busy)
                  .text-center.my-5
                    b-spinner.mr-2(variant="primary" small)
                    span.text-muted Loading assessments...
                
                template(#empty="scope")
                  .text-center.py-5
                    .empty-state
                      BIconFileEarmarkText.mb-3(style="font-size: 3rem; color: #6c757d;")
                      h5.text-muted No {{ selectedTable }} assessments found
                      p.text-secondary Try adjusting your search or check the other table type.
                
                template(#cell(name)="data")
                  .client-name
                    .font-weight-semibold.text-dark {{ data.item.crb5c_clientname }}
                
                template(#cell(dateLastAssessment)="data")
                  .assessment-date
                    span.badge.badge-light.px-2.py-1(v-if="data.item.crb5c_dateofassessment")
                      BIconCalendar3.mr-1(style="font-size: 0.8rem;")
                      | {{ formatDate(data.item.crb5c_dateofassessment) }}
                    span.text-muted.font-italic(v-else) No data available
                
                template(#cell(Moca)="data")
                  .score-container
                    .score-badge.badge-dark
                      | {{ data.item.crb5c_mocatotalscore || "N/A" }}
                
                template(#cell(EQ5DL)="data")
                  .score-container
                    .score-badge.badge-dark
                      | {{ data.item.crb5c_eqtotalscore || "N/A" }}
                
                template(#cell(Phase)="data")
                  .phase-container
                    .badge.badge-info.px-2.py-2.rounded-pill(v-if="data.item.crb5c_cipphase")
                      span Phase {{ data.item.crb5c_cipphase }} 
                    span.text-muted.font-italic(v-else) Not assigned
                
                template(#cell(lastPhaseDate)="data")
                  .phase-container
                    .px-2.py-2(v-if="data.item.crb5c_phaseenddate")
                      span {{formatDate(data.item.crb5c_phaseenddate)}} 
                      span.font-weight-bold ({{ daysLeft(data.item.crb5c_phaseenddate) }})
                    span.text-muted.font-italic(v-else) No data available
                
                template(#cell(Actions)="data")
                  .action-buttons
                    b-button.follow-up-btn(
                      :variant="getButtonStatus(data.item) === 'discontinued' ? 'danger' : getButtonStatus(data.item) === 'toNextPhase' ? 'success' : 'primary'"
                      size="sm"
                      :class="checkdue(data.item)"
                      :disabled="getButtonStatus(data.item) === 'toNextPhase' || getButtonStatus(data.item) === 'discontinued'"
                      @click="followUpAssessment(data.item.crb5c_clientid)"
                      style="border-radius: 20px; font-weight: 500; padding: 0.375rem 1rem;"
                    )
                      BIconCheckCircleFill.mr-1(v-if="getButtonStatus(data.item) === 'toNextPhase'")
                      BIconXCircleFill.mr-1(v-else-if="getButtonStatus(data.item) === 'discontinued'")
                      BIconArrowRight.mr-1(v-else)
                      | {{ getButtonStatus(data.item) === 'toNextPhase' ? 'Continued Next Phase' : getButtonStatus(data.item) === 'discontinued' ? 'Discontinued' : 'Follow-Up' }}
</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';

export default {
  data() {
    return {
      isFetchingAdminDashboardData: true,
      clientsList: null,
      isSendEmail: false,
      inputSearchItemList: '',
      currentPage: 0,
      pageSize: 2,
      visibleList: [],
      clientAsessmentDB: [],
      careGiverDB: [],
      selectedTable: 'CIP', 
      tableOptions: [
        { text: 'FOW', value: 'FOW' },
        { text: 'CIP', value: 'CIP' }
      ],
      selectedPhase: 1,
      phaseOptions: [
        { text: 'Phase 1', value: 1 },
        { text: 'Phase 2', value: 2 },
        { text: 'Phase 3', value: 3 },
      ],
      fowTableFields: [
        { 
          key: 'name', 
          label: 'Name',
        }, 
        { 
          key: 'dateLastAssessment', 
          label: 'Date Done',
        }, 
        { 
          key: 'Moca', 
          label: 'Moca Score',
        }, 
        { 
          key: 'EQ5DL', 
          label: 'EQ5DL Score',
        },
        'Actions',
      ],
      cipTableFields: [
        { 
          key: 'name', 
          label: 'Name',
        }, 
        { 
          key: 'dateLastAssessment', 
          label: 'Last Done',
        }, 
        { 
          key: 'Moca', 
          label: 'Moca',
        }, 
        { 
          key: 'EQ5DL', 
          label: 'EQ5DL',
        },
        { 
          key: 'Phase', 
          label: 'Phase',
        }, 
        { 
          key: 'lastPhaseDate', 
          label: 'Phase End Date',
        },
        'Actions',
      ],
      isActive: true,
      modalEmailMessage: {
        id: null,
        inputEmailMessage: null,
        caregiverEmail: null,
      },
      sendModal: {
        modalClientId: null,
        data: null,
      },
      currentClient: null,
      isButtonDisabled: {},
      listCIPModalSelected: [],
      listAppointmentsSelected: [],
      isSent: {},
    }
  },
  computed: {
    currentTableFields() {
      return this.selectedTable === 'FOW' ? this.fowTableFields : this.cipTableFields;
    },
    currentTableData() {
      if (!this.clientsList) return [];
      
      if (this.selectedTable === 'FOW') {
        return this.clientsList.filter(client => !client.crb5c_cipphase);
      } else {
        return this.clientsList.filter(client => client.crb5c_cipphase);
      }
    },
    filteredClientsList() {
      let filtered = [...this.currentTableData];
      
      if (this.selectedTable === 'CIP' && this.selectedPhase) {
        filtered = filtered.filter(client => 
          client.crb5c_cipphase === this.selectedPhase
        );
      }
      
      if (this.inputSearchItemList.trim()) {
        const searchTerm = this.inputSearchItemList.trim().toLowerCase();
        filtered = filtered.filter(client => 
          client.crb5c_clientname.toLowerCase().includes(searchTerm)
        );
      }
      
      filtered.sort((a, b) => {
        const dateA = a.crb5c_dateofassessment ? dayjs(a.crb5c_dateofassessment) : dayjs(0);
        const dateB = b.crb5c_dateofassessment ? dayjs(b.crb5c_dateofassessment) : dayjs(0);
        return dateB.valueOf() - dateA.valueOf(); 
      });
      
      return filtered;
    }
  },
  methods: {
    getButtonStatus(item) {
      const clientId = item.crb5c_clientid;
      const currentPhase = this.selectedPhase;
      
      // Get all records for this client
      const clientRecords = this.clientsList.filter(client => client.crb5c_clientid === clientId);
      
      if (currentPhase === 1) {
        const hasPhase2 = clientRecords.some(client => client.crb5c_cipphase === 2);
        const discontinue = clientRecords.some(client => client.crb5c_notjoining === true);
        if (!discontinue && hasPhase2) {
          return 'toNextPhase';
        }
        if (discontinue) {
          return 'discontinued';
        }
        return 'followUp';
      }
      
      if (currentPhase === 2) {
        const hasPhase3 = clientRecords.some(client => client.crb5c_cipphase === 3);
        const discontinue = clientRecords.some(client => client.crb5c_notjoining === true);
        if (!discontinue && hasPhase3) {
          return 'toNextPhase'; 
        }
        if (discontinue) {
          return 'discontinued'; 
        }
        return 'followUp';
      }
      
      return 'followUp';
    },
    
    isClientDiscontinued(item) {
      return item.crb5c_notjoining === true;
    },
    
    checkCompletion(item){
      const status = this.getButtonStatus(item);
      return status === 'toNextPhase' || status === 'discontinued';
    },
    daysLeft(endDate) {
      if (!endDate) return '';
      const end = dayjs(endDate);
      const now = dayjs();
      const diff = end.diff(now, 'day');
      if (diff  == 0) {
        return 'Today';
      }
      else if (diff == 1) {
        return 'Tomorrow';
      }
      else if (diff < 0) {
        return 'Past';
      }
      return diff >= 2 ? diff + " days left" : '';
    },
    checkdue(item) {
      const phaseEndDate = item.crb5c_phaseenddate;
      if (!phaseEndDate) return 'enabled-button';
      
      const endDate = dayjs(phaseEndDate);
      const now = dayjs();
      const diff = endDate.diff(now, 'day');
      
      if (diff <= 7 && diff >= 0) {
        return 'enabled-button alert-button bouncing';
      }
      
      return 'enabled-button';
    },
    async followUpAssessment(id){
      this.$root.redirectToClientAssessment(id)
    },
    async getAssessments(){
      try {
          const {data} = await axios.get('/api/assessment')
        if(data.assessment){
          this.clientsList = data.assessment;
        }
      } catch (error) {
        console.error("Error fetching assessment data:", error);
      }
      this.isFetchingAdminDashboardData = false;
    },
    formatDate(rawDate){
      return dayjs(rawDate).format('DD-MMM-YY');
    },
    getEQScoreClass(score) {
      if (!score) return 'badge-secondary';
      const numScore = parseFloat(score);
      if (numScore >= 0.8) return 'badge-success';
      if (numScore >= 0.6) return 'badge-warning';
      return 'badge-danger';
    },
    updatePage(pageNumber){
      this.currentPage = pageNumber
      this.updateVisibleList()
    },
    backAdminHomepage() {
      this.$router.push({ path: '/adminhomepage' })
    },
    removeCurlyBracesFromStringClientId(clientId){
      return clientId.replace(/[{}]/g, '');
    },
    openEmailMessageModal(clientId, caregiverEmail){
      if(!caregiverEmail){
        alert("Caregiver email is missing");
        return;
      }
      this.modalEmailMessage.caregiverEmail = caregiverEmail;
      this.modalEmailMessage.id = `modalEmailMessage/${this.removeCurlyBracesFromStringClientId(clientId)}`;
      this.$nextTick(() => {
        this.$bvModal.show(this.modalEmailMessage.id)
      });
    },
    closeEmailMessageModal(){
      this.$bvModal.hide(this.modalEmailMessage.id);
      this.modalEmailMessage.id = null;
      this.modalEmailMessage.inputEmailMessage = null;
      this.modalEmailMessage.caregiverEmail = null;
    },
    moveToHomePage(){
      this.$router.push({ path: "/" })
    },
  },
  async mounted(){
    await this.getAssessments();
  }
};
</script>

<style scoped>
.text-primary {
  color: #50276D !important;
}

.toggle-buttons >>> .btn-group {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 25px;
  overflow: hidden;
}

.toggle-button{
  border-radius: 0;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
  overflow: hidden;
}

.toggle-buttons >>> .btn {
  border-radius: 0;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.toggle-buttons >>> .btn-outline-primary {
  border-color: #50276D;
  color: #50276D;
}

.toggle-buttons >>> .btn-outline-primary:not(.active):hover {
  background-color: #50276D;
  color: white;
  transform: translateY(-1px);
}

.toggle-buttons >>> .btn-outline-primary.active {
  background-color: #50276D;
  border-color: #50276D;
  color: white;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.2);
}

.search-container {
  position: relative;
}

.search-input {
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.search-input:focus {
  border-color: #50276D !important;
  box-shadow: 0 0 0 0.2rem rgba(80, 39, 109, 0.25) !important;
}

.search-icon {
  color: #6c757d;
  z-index: 5;
}

.stats-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-radius: 10px;
}

.stats-text {
  font-size: 1.1rem;
}

.table-container {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  overflow: hidden;
}

.table-wrapper {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.custom-table {
  margin-bottom: 0;
  font-size: 0.95rem;
}

.table-header-custom {
  background: linear-gradient(135deg, #50276D 0%, #6a3093 100%) !important;
  color: white !important;
  border: none !important;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table-header-custom th {
  border: none !important;
  padding: 1rem 0.75rem;
  vertical-align: middle;
}

.table-row-hover {
  transition: all 0.2s ease;
  cursor: pointer;
}

.table-row-hover:hover {
  background-color: #f8f9ff !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.client-name {
  font-size: 1rem;
}

.assessment-date .badge {
  background-color: #e9ecef;
  color: #495057;
  font-weight: 500;
}

.score-container .score-badge {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.875rem;
  min-width: 60px;
  text-align: center;
}

.score-badge.badge-success {
  background-color: #28a745;
  color: white;
}

.score-badge.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.score-badge.badge-danger {
  background-color: #dc3545;
  color: white;
}

.score-badge.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.phase-container .badge {
  font-size: 0.85rem;
  font-weight: 500;
}

.action-buttons {
  display: flex;
  justify-content: center;
}

.follow-up-btn {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
  transition: all 0.3s ease;
  font-size: 0.875rem;
}

.follow-up-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

.empty-state {
  padding: 2rem;
}

.table-wrapper::-webkit-scrollbar {
  width: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #50276D 0%, #6a3093 100%);
  border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #6a3093 0%, #50276D 100%);
}

@media (max-width: 768px) {
  .stats-container {
    flex-direction: column;
    text-align: center;
  }
  
  .stats-container .table-indicator {
    margin-top: 0.5rem;
  }
  
  .toggle-buttons >>> .btn {
    padding: 0.375rem 1rem;
    font-size: 0.875rem;
  }
  
  .custom-table {
    font-size: 0.875rem;
  }
  
  .table-header-custom th {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }
}

.enabled-button {
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

.disabled-button {
  background-color: inherit;
  color: black;
  border: none;
  cursor: not-allowed;
}

.table-header-color {
  background-color: #50276D;
}

.alert-button {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
  border-color: #dc3545 !important;
  color: white !important;
  box-shadow: 0 0 20px rgba(220, 53, 69, 0.4);
  position: relative;
  overflow: hidden;
}

.alert-button:hover {
  background: linear-gradient(135deg, #c82333 0%, #a71e2a 100%) !important;
  border-color: #c82333 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 25px rgba(220, 53, 69, 0.6);
}

.alert-button:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5) !important;
}


.alert-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  border-radius: inherit;
  opacity: 0;
  animation: pulse-glow 2s infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    opacity: 0;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}

.bouncing {
  animation: bounce-urgent 1.5s infinite;
}

@keyframes bounce-urgent {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-8px);
  }
  60% {
    transform: translateY(-4px);
  }
}


.alert-button .icon-urgent {
  animation: flash 1s infinite;
}

@keyframes flash {
  0%, 50%, 100% {
    opacity: 1;
  }
  25%, 75% {
    opacity: 0.5;
  }
}
.urgent-indicator {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ffc107;
  color: #212529;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.follow-up-btn.alert-button {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
}

.follow-up-btn.alert-button:hover {
  background: linear-gradient(135deg, #c82333 0%, #a71e2a 100%) !important;
  transform: translateY(-2px) !important;
}

.alert-button .urgent-text {
  font-weight: 700 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
</style>